@if (qualificationVersions?.length) {
  <ag-grid-angular
    class="ag-theme-wilson"
    [rowData]="qualificationVersions"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [components]="components"
    [columnDefs]="columnDefs"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
} @else {
  <p class="text-dark">
    {{ 'page.qualifications.no_older_versions' | translate }}
  </p>
}
